import { render } from "./EmploymentsModal.vue?vue&type=template&id=52767fd4"
import script from "./EmploymentsModal.vue?vue&type=script&lang=js"
export * from "./EmploymentsModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/springup/oa-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__